import { render, staticRenderFns } from "./GenericGameStatsChart.vue?vue&type=template&id=90c27c64&"
import script from "./GenericGameStatsChart.vue?vue&type=script&lang=js&"
export * from "./GenericGameStatsChart.vue?vue&type=script&lang=js&"
import style0 from "./GenericGameStatsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports